export interface IAuthStore {
  accessToken: string;
  refreshToken: string;
  userData: IUser;
  logging: boolean;
  isAuthenticated: boolean;
  login(email: string, password: string): Promise<any>;
  createAdmin(user: any): Promise<any>;
  logout(): void;
  updateTokens(): void;
  getCurrentUser(): void;
}

export interface IUser {
  firstName: string;
  firstNameAr: string;
  lastName: string;
  profilePicture: string;
  phoneNumber: string;
  hasSeenTooltip: boolean;
  userId: string;
  membershipId: string;
  email: string;
  role: {
    title: string;
  };
  countries: ICountry[];
}
export interface ICountry {
  countryId: number;
  isoCode: string;
  name: string;
}
export const emptyUser: IUser = {
  firstName: '',
  firstNameAr: '',
  lastName: '',
  profilePicture: '',
  phoneNumber: '',
  hasSeenTooltip: false,
  userId: '',
  membershipId: '',
  email: '',
  role: {
    title: '',
  },
  countries: [],
};

export interface ChangePasswordData {
  oldPassword: string;
  newPassword: string;
  adminPassword: string;
}

export interface ChangeMembershipIdData {
  userId: number;
  newMembershipId: string;
}
